import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { Report2CAExportRequest } from '../requests/Report2CARequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const Report2CAExport = (values, userId) => async (dispatch) => {
	await Report2CAExportRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
